import { CommentModel } from '@modules/comment/comment-model';

const { fields } = CommentModel;

export default [
  fields.id,
  fields.admin,
  fields.comment,
  fields.status,
  fields.createdAt
];
